module.exports = __webpack_public_path__ + "static/bsas020-c338aacbadcec4254fb2fb89f24cc36c.jpg";